import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { memo } from "react";
import { Tooltip } from "../../Tooltip/index.js";
import { Button } from "../../Button/index.js";
import { useFilesService } from "../../services/hooks/index.js";
import { Box } from "../../Box/index.js";
import { Counter } from "../../Counter/index.js";
import { Paper } from "../../Paper/index.js";
import { FilePreview } from "../../FilePreview/index.js";
import { Icon } from "../../Icon/index.js";
import { Typography } from "../../Typography/index.js";
import { EllipsisText } from "../../EllipsisText/index.js";
import MultipleFileInput_styles from "./MultipleFileInput.styles.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MultipleFileInputPreview_MultipleFileInputPreview = /*#__PURE__*/ memo(function(t0) {
    const $ = c(31);
    const { file, index, removeDocument, disabled, withAuth, withCounter: t1, testId } = t0;
    const withCounter = void 0 === t1 ? true : t1;
    const { classes } = MultipleFileInput_styles();
    const filesService = useFilesService();
    let t2;
    if ($[0] !== file.source || $[1] !== filesService || $[2] !== withAuth) {
        t2 = ()=>_async_to_generator(function*() {
                if ("string" != typeof file.source) return file.source;
                {
                    const fileData = yield filesService.getFile(file.source, withAuth);
                    const loadedFile = yield fileData.file;
                    return loadedFile;
                }
            })();
        $[0] = file.source;
        $[1] = filesService;
        $[2] = withAuth;
        $[3] = t2;
    } else t2 = $[3];
    const load = t2;
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            xs: 92,
            sm: 140
        };
        t4 = {
            xs: 92,
            sm: 140
        };
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    const t5 = `${testId}-preview-${index}`;
    let t6;
    if ($[6] !== index || $[7] !== withCounter) {
        t6 = withCounter && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 10,
            left: 10,
            radius: "round",
            height: 20,
            width: 20,
            zIndex: 1,
            children: /*#__PURE__*/ jsx(Counter, {
                backgroundColor: "gray",
                counter: index + 1
            })
        });
        $[6] = index;
        $[7] = withCounter;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== disabled || $[10] !== index || $[11] !== removeDocument || $[12] !== testId) {
        t7 = !disabled && /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            top: 7,
            right: 8,
            zIndex: 1,
            children: /*#__PURE__*/ jsx(Button, {
                size: "extraSmall",
                variant: "quaternaryAccent",
                onClick: removeDocument,
                testId: `${testId}-remove-${index}`,
                icon: /*#__PURE__*/ jsx(Icon, {
                    name: "cancel",
                    size: "16",
                    color: "original.brand.primary"
                })
            })
        });
        $[9] = disabled;
        $[10] = index;
        $[11] = removeDocument;
        $[12] = testId;
        $[13] = t7;
    } else t7 = $[13];
    const t8 = "string" != typeof file.source && file.source.name || "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F";
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            xs: "2",
            md: "4"
        };
        $[14] = t9;
    } else t9 = $[14];
    const t10 = "string" != typeof file.source && file.source.name || "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F";
    let t11;
    if ($[15] !== t10) {
        t11 = /*#__PURE__*/ jsx(Box, {
            position: "absolute",
            bottom: 1,
            right: 1,
            zIndex: 1,
            left: 1,
            bgcolor: "bg.greyscale.primary",
            py: t9,
            px: "12",
            borderBottomLeftRadius: "l",
            borderBottomRightRadius: "l",
            children: /*#__PURE__*/ jsx(EllipsisText, {
                rows: 1,
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    children: t10
                })
            })
        });
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11 || $[18] !== t8) {
        t12 = /*#__PURE__*/ jsx(Tooltip, {
            title: t8,
            placement: "bottom",
            children: t11
        });
        $[17] = t11;
        $[18] = t8;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== load) {
        t13 = /*#__PURE__*/ jsx(FilePreview, {
            onLoad: load,
            clickable: true
        });
        $[20] = load;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== classes.filePreviewPaper || $[23] !== t13) {
        t14 = /*#__PURE__*/ jsx(Paper, {
            className: classes.filePreviewPaper,
            children: t13
        });
        $[22] = classes.filePreviewPaper;
        $[23] = t13;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== t12 || $[26] !== t14 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
        t15 = /*#__PURE__*/ jsxs(Box, {
            position: "relative",
            width: t3,
            height: t4,
            testId: t5,
            children: [
                t6,
                t7,
                t12,
                t14
            ]
        });
        $[25] = t12;
        $[26] = t14;
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t15;
    } else t15 = $[30];
    return t15;
});
export { MultipleFileInputPreview_MultipleFileInputPreview as MultipleFileInputPreview };
